import React from 'react'
import { RenderControl } from '@fareye/ui'
import {
  isEmpty,
  cancelToken,
  post,
  responseParser,
  groupBy
} from '@fareye/utils'
import { mapping } from '../../../config/mapComponents'
import { zonedToUTC, zonedToUTCAdd1Day, useTranslation } from '@fareye/common'
import { RouteContainerGrid } from '../../../style/styled'

const MultiModalRoute = ({
  match,
  config,
  history,
  endDate,
  location,
  startDate,
  globalSearch,
  setTransportModeFilter,
  setSummaryData,
  selectedMode,
  summaryFilter
}: any) => {
  const source = cancelToken().source()
  const {
    config: { apiConfig },
    styling,
    children
  } = config
  const { style, className } = styling
  const compName: any = (children as any).component
  const Component = children && (mapping as any)[compName]
  const [apiResponse, setApiResponse] = React.useState<any>({
    data: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
  })
  const { t } = useTranslation()
  function generateFilterDataFromGlobalSearch(globalSearch: any[]) {
    if (isEmpty(globalSearch)) {
      return []
    } else {
      const groupedSearch = groupBy(globalSearch, ele => ele.key)
      return Object.entries(groupedSearch).map(([key, value]) => {
        return [
          {
            filterKey: key,
            filterValue: value.reduce((res = [], obj) => {
              res.push(obj.value)
              return res
            }, []),
            condition: 'include',
            filterType: 'eq'
          }
        ]
      })
    }
  }
  function generateFilterObjectForDateRange(startDate: any, endDate: any) {
    const startFilter = [
      {
        filterKey: 'start_date',
        filterValue: startDate ? zonedToUTC(startDate) : new Date(),
        condition: 'include',
        filterType: 'gte'
      }
    ]
    const endFilter = [
      {
        filterKey: 'start_date',
        filterValue: endDate ? zonedToUTCAdd1Day(endDate) : new Date(),
        condition: 'include',
        filterType: 'lt'
      }
    ]
    const isActiveFilter = [
      {
        filterKey: 'is_active',
        filterValue: false,
        condition: 'include',
        filterType: 'eq'
      }
    ]
    return [startFilter, endFilter, isActiveFilter]
  }
  function generateFilterDataFromAggregation() {
    let aggsType: any[] = []
    if (!isEmpty(summaryFilter?.key)) {
      let diffAggs = Object.keys(summaryFilter.key)
      diffAggs.forEach((key: string) => {
        aggsType.push({
          filterKey: key,
          filterValue: summaryFilter.key[key],
          condition: 'include',
          filterType: 'eq'
        })
      })
    }
    return aggsType ? aggsType : []
  }

  async function fetchData() {
    try {
      setApiResponse({ ...apiResponse, isLoading: true })
      setSummaryData([])
      let filter = generateFilterDataFromGlobalSearch(globalSearch)
      const dateFilter = generateFilterObjectForDateRange(startDate, endDate)
      const aggsFilter = generateFilterDataFromAggregation()
      filter = [...filter, ...dateFilter, ...[aggsFilter]]
      const {
        data: { content, content_summary, transport_mode_summary },
        message,
        error
      } = responseParser(
        await post(
          `${apiConfig && apiConfig.apiURL}`,
          {
            filter,
            perPage: 10000,
            page: 1,
            // aggs: apiConfig.queryParams.aggs ? apiConfig.queryParams.aggs : []
            aggs: ['status', 'transport_mode', 'route_string']
          },
          source.token
        )
      )

      setTransportModeFilter(transport_mode_summary)
      setSummaryData(content_summary ? content_summary : [])
      setApiResponse({
        ...apiResponse,
        isError: error,
        data: error ? content : content ? content : [], // FIXME: Weird should be []
        isSuccess: true,
        isLoading: false,
        message: error
          ? message
          : isEmpty(content)
          ? apiConfig && apiConfig.apiDataState
            ? apiConfig.apiDataState.noDataMessage
            : 'No Data Found'
          : ''
      })
    } catch (err:any) {
      const { message, error } = responseParser(err.response)
      setApiResponse({
        ...apiResponse,
        isSuccess: false,
        isError: true,
        isLoading: false,
        message
      })
      console.error('App Error:', error)
    }
  }

  React.useEffect(() => {
    fetchData()
    return () => {
      source.cancel('Unsubscribe Before Unmount')
    }
    // eslint-disable-line
  }, [globalSearch, startDate, endDate, summaryFilter])

  const { data } = apiResponse
  const transporterData = !isEmpty(data) ? data : []
  const filteredData =
    selectedMode.toLowerCase() === 'all'
      ? transporterData
      : transporterData.filter((item: any) =>
          item.transportMode.includes(selectedMode.toLowerCase())
        )
  return (
    <RenderControl state={apiResponse} variant={'l'} t={t}>
      <RouteContainerGrid
        style={{ ...style, padding: '1em' }}
        className={className}
      >
        {filteredData
          .sort((a: any, b: any) => {
            return a.totalTrips > b.totalTrips ? -1 : 1
          })
          .map((item: any, index: number) => (
            <Component
              {...item}
              match={match}
              history={history}
              endDate={endDate}
              location={location}
              startDate={startDate}
              key={`TransportersDetailsCard${index}`}
              config={config.children}
            />
          ))}
      </RouteContainerGrid>
    </RenderControl>
  )
}

export default MultiModalRoute
